var _path, _path2, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2772_128739)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06878 22.8638C1.76317 21.7233 1.92316 20.5081 2.51354 19.4855C3.10391 18.463 4.07632 17.7168 5.21684 17.4112L33.3124 9.88302C34.4529 9.57742 35.6681 9.73741 36.6907 10.3278C37.7133 10.9182 38.4594 11.8906 38.765 13.0311L46.2932 41.1266C46.5988 42.2672 46.4388 43.4824 45.8484 44.5049C45.2581 45.5275 44.2856 46.2737 43.1451 46.5793L15.0496 54.1074C13.909 54.413 12.6938 54.2531 11.6713 53.6627C10.6487 53.0723 9.90256 52.0999 9.59696 50.9594L2.06878 22.8638Z",
    fill: "#AE9AFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2772_128739",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3569 20.5614L17.4461 22.6811C13.9014 23.6309 11.7978 27.2744 12.7476 30.8191L14.8673 38.73C15.8171 42.2747 19.4606 44.3783 23.0053 43.4285L30.9162 41.3088C34.4609 40.359 36.5645 36.7155 35.6147 33.1708L33.495 25.2599C32.5452 21.7152 28.9016 19.6116 25.3569 20.5614Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2772_128739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2645 21.4658L17.9797 23.4178C14.7155 24.2924 12.7784 27.6476 13.653 30.9118L15.605 38.1966C16.4796 41.4608 19.8348 43.3979 23.099 42.5233L30.3838 40.5713C33.648 39.6967 35.5851 36.3415 34.7104 33.0773L32.7585 25.7925C31.8838 22.5283 28.5287 20.5912 25.2645 21.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.403 21.6249C22.7292 21.2695 24.0526 20.9037 25.3816 20.5588C26.9033 20.1723 28.5123 20.3321 29.9282 21.0105C31.344 21.6889 32.4768 22.8428 33.1289 24.2709C33.2879 24.619 33.4179 24.9796 33.5178 25.349C34.2157 27.9208 34.8976 30.4985 35.5902 33.0685C35.9722 34.48 35.8835 35.9775 35.3376 37.334C34.7916 38.6905 33.8183 39.832 32.5651 40.5854C32.0393 40.902 31.4716 41.1427 30.8785 41.3005C28.262 42.0016 25.6535 42.7357 23.0257 43.395C20.4773 44.0339 18.2629 43.361 16.4274 41.4876C15.6567 40.7006 15.1475 39.7468 14.861 38.6805C14.1611 36.0684 13.4533 33.4657 12.7639 30.854C12.2886 29.0472 12.5385 27.3261 13.4852 25.7158C14.2177 24.4572 15.3487 23.4787 16.6995 22.9348C16.9688 22.8257 17.2449 22.7344 17.5261 22.6613C18.8176 22.3137 20.1097 21.9714 21.403 21.6249ZM26.264 39.7661L30.0545 38.7505C30.2113 38.7122 30.366 38.6657 30.5179 38.6111C31.385 38.2903 32.1134 37.6777 32.5781 36.8784C33.1241 35.9459 33.2912 34.9396 33.0178 33.8954C32.3316 31.2717 31.6138 28.6556 30.9166 26.0356C30.7497 25.3668 30.4041 24.756 29.9167 24.2686C28.8203 23.1826 27.5071 22.7865 26.0124 23.1758C23.3897 23.8538 20.7773 24.5706 18.1614 25.2739C18.0014 25.3161 17.8447 25.3698 17.6925 25.4347C16.7946 25.8023 16.0639 26.4883 15.6403 27.3612C15.2089 28.2351 15.0901 29.1556 15.3432 30.1005C16.04 32.7267 16.7431 35.3507 17.4525 37.9725C17.5076 38.1747 17.5772 38.3725 17.6608 38.5646C18.422 40.3308 20.456 41.3184 22.3123 40.825C23.6307 40.4733 24.9479 40.1204 26.264 39.7661Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5226 30.0966L21.4505 33.6777L19.1407 32.3561L19.887 31.0843L18.5928 30.3384L19.9305 28.0227L23.5226 30.0966Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7126 28.6932L26.6313 32.2905L24.3335 30.9689L25.0812 29.6935L23.7823 28.9536L25.1262 26.6226L28.7126 28.6932Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5368 37.0488C25.1845 37.1219 24.8234 37.143 24.4649 37.1113C23.6606 37.0588 22.8594 37.0151 22.057 36.967C21.5043 36.9343 21.1136 36.5359 21.1282 36.0232C21.1419 35.4596 21.6177 35.0649 22.1908 35.129C22.8865 35.2057 23.5817 35.2866 24.2787 35.3534C24.8394 35.4068 25.3995 35.2461 25.8467 34.9037C26.396 34.5029 26.9436 34.0986 27.493 33.6979C27.5986 33.6185 27.7201 33.5627 27.8491 33.5344C27.9795 33.5059 28.1146 33.5066 28.2448 33.5364C28.375 33.5654 28.4973 33.6224 28.6031 33.7035C28.7088 33.7851 28.7956 33.8884 28.8579 34.0064C28.967 34.2102 28.9949 34.4477 28.9361 34.6712C28.8773 34.8947 28.736 35.0876 28.5408 35.2112C28.0541 35.5384 27.5631 35.8612 27.0711 36.1834C26.7272 36.4075 26.3841 36.6314 26.0317 36.8418C25.8713 36.9212 25.706 36.9903 25.5368 37.0488Z",
    fill: "#222222"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2772_128739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9561 6.85558C45.5465 5.83302 46.5189 5.08686 47.6594 4.78126C48.7999 4.47566 50.0151 4.63564 51.0377 5.22602L76.2275 19.7693C77.2501 20.3597 77.9962 21.3321 78.3018 22.4727C78.6074 23.6132 78.4474 24.8284 77.857 25.8509L63.3137 51.0407C62.7233 52.0633 61.7509 52.8094 60.6104 53.1151C59.4699 53.4207 58.2547 53.2607 57.2321 52.6703L32.0423 38.127C31.0198 37.5366 30.2736 36.5642 29.968 35.4237C29.6624 34.2831 29.8224 33.0679 30.4128 32.0454L44.9561 6.85558Z",
    fill: "#C4B6FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2772_128739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7784 21.3179L56.1581 17.4956C52.9642 15.6516 48.8807 16.7449 47.0375 19.9375L43.2125 26.5625C41.3693 29.7551 42.4642 33.8381 45.6581 35.6821L52.2784 39.5044C55.4724 41.3484 59.5558 40.2551 61.3991 37.0625L65.224 30.4375C67.0673 27.2449 65.9724 23.1619 62.7784 21.3179Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4275 23.6689L54.8072 19.8467C52.8847 18.7367 50.4267 19.3948 49.3172 21.3165L45.4916 27.9427C44.3821 29.8644 45.0411 32.3221 46.9636 33.4321L53.584 37.2543C55.5065 38.3643 57.9644 37.7062 59.0739 35.7845L62.8996 29.1583C64.0091 27.2366 63.35 24.7789 61.4275 23.6689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3574 27.6018L53.9108 25.9325L55.5408 25.4961L54.8481 22.9129L53.2174 23.3505L52.7805 21.7176L50.197 22.4093L50.6346 24.041L48.9645 24.4881L49.6572 27.0714L51.3266 26.6254L51.7739 28.2935L54.3574 27.6018Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4556 31.1223L60.009 29.453L61.6389 29.0166L60.9462 26.4334L59.3155 26.871L58.8787 25.2381L56.2952 25.9298L56.7327 27.5615L55.0626 28.0086L55.7553 30.5919L57.4247 30.1459L57.872 31.814L60.4556 31.1223Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8966 31.1503L52.2004 30.1709C51.5647 29.8039 50.7519 30.0215 50.385 30.6569C50.0181 31.2924 50.2361 32.1051 50.8718 32.4721L52.5681 33.4514C53.2038 33.8184 54.0165 33.6008 54.3834 32.9654C54.7503 32.3299 54.5323 31.5173 53.8966 31.1503Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2772_128739",
    x: 24.8164,
    y: 0.629395,
    width: 58.6372,
    height: 58.6372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2772_128739"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2772_128739",
    result: "effect2_dropShadow_2772_128739"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2772_128739",
    result: "effect3_dropShadow_2772_128739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2772_128739",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2772_128739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9907,
    height: 37.9907,
    fill: "white",
    transform: "translate(0.916504 18.5635) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2772_128739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(50.375 14.1567) rotate(30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotsPlaceholder);
export default __webpack_public_path__ + "static/media/bots-placeholder.8d028df1288b9516631a8597f1d4f888.svg";
export { ForwardRef as ReactComponent };